import axios from '@/axios.js'

// @/axios.js sets no baseURL or Authorization header, so every call adds both here.
// It's still the shared instance, so its 401 interceptor applies.
const BASE_URL = process.env.VUE_APP_API_BASE_URL

function request(method, path, { params, data } = {}) {
  return axios
    .request({
      method,
      url: `${BASE_URL}${path}`,
      params,
      data,
      headers: { Authorization: localStorage.getItem('auth_token') }
    })
    .then(res => res.data)
}

const base = (reId) => `/review_entities/${reId}/providers`

export const listProviders = (reId, llm) =>
  request('get', base(reId), { params: llm ? { llm_provider: llm } : {} })

export const addProvider = (reId, body) => request('post', base(reId), { data: body })

export const assignNpi = (reId, profileId, npi) =>
  request('patch', `${base(reId)}/${profileId}/npi`, { data: { npi } })

export const mergeProviders = (reId, profileId, intoId) =>
  request('post', `${base(reId)}/${profileId}/merge`, { data: { into_profile_id: intoId } })

export const getVisibility = (reId, profileId, llm) =>
  request('get', `${base(reId)}/${profileId}/visibility`, { params: llm ? { llm_provider: llm } : {} })

export const searchNpi = (q, reId) =>
  request('get', '/npi_registry/search', { params: { q, review_entity_id: reId } })

// Audit-wide provider questions: one set per audit, written from the service line questions.
const pq = (reId) => `/review_entities/${reId}/provider_questions`

export const getProviderQuestions = (reId) => request('get', pq(reId))

export const updateProviderQuestions = (reId, questions) =>
  request('patch', pq(reId), { data: { questions } })

export const resetProviderQuestion = (reId, queryId) =>
  request('post', `${pq(reId)}/${queryId}/reset`)

export const confirmProviderQuestions = (reId) => request('post', `${pq(reId)}/confirm`)

export const retryProviderQuestions = (reId) => request('post', `${pq(reId)}/retry`)

export const skipProviderQuestions = (reId) => request('post', `${pq(reId)}/skip`)
